// /**
//  * SEO component that queries for data with
//  *  Gatsby's useStaticQuery React hook
//  *
//  * See: https://www.gatsbyjs.org/docs/use-static-query/
//  */

import React, { ReactNode } from "react"
import config from "../config"

export interface MetaProp {
  name: string
  content: string
}

export interface SEOProp {
  description: string
  meta: MetaProp[]
  keywords: string[]
  title: string
  thumbnail: string
  jsonld: (any & {
    "@type": string
  }) []
  children?: ReactNode
}

function SEO(props: SEOProp) {
//   const { site } = useStaticQuery(
//     graphql`
//       query {
//         site {
//           siteMetadata {
//             title
//             description
//             author
//             siteUrl
//             thumbnailUrl
//           }
//         }
//       }
//     `
//   )
  if (props.jsonld.map(x => x['@type']).indexOf('WebSite') === -1) {
    props.jsonld.push({
      '@context': 'http://schema.org',
      '@type': 'WebSite',
      name: config.title,
      url: config.siteUrl,
      description: config.description,
      thumbnailUrl: config.thumbnailUrl,
      mainEntityOfPage: {
        '@type': 'WebPage',
        '@id': config.siteUrl
      },
      headline: config.title,
      copyrightHolder: {
        '@type': 'Person',
        'name': '山田良太'
      },
      copyrightYear: 2021,
      datePublished: '2021-01-01',
    })
  }
  if (props.jsonld.map(x => x['@type']).indexOf('Organization') === -1) {
    props.jsonld.push({
      '@type': 'Organization',
      name: 'SEM Technology',
      logo: config.thumbnailUrl
    })
  }

  const metaDescription = props.description || config.description

  return (
    <>
      <title>{props.title}</title>
      <meta name="description" content={metaDescription} />
      <meta property="og:title" content={props.title} />
      <meta property="og:image" content={props.thumbnail ? `${config.siteUrl}${props.thumbnail}` : ""} />
      <meta property="og:type" content="website" />
      <meta name="twitter:card" content="summary" />
      <meta name="twitter:creator" content={config.author} />
      <meta name="twitter:title" content={props.title} />
      <meta name="twitter:description" content={metaDescription} />
      <meta name="google-site-verification" content={process.env.GOOGLE_SITE_VERIFICATION} />
      {props.keywords.length > 0 && (
        <meta name="keywords" content={props.keywords.join(`, `)} />
      )}
      {props.jsonld.length > 0 && (
        <script type="application/ld+json">
          {JSON.stringify(props.jsonld)}
        </script>
      )}
      <script src="https://apis.google.com/js/client.js"></script>
      {props.children}
    </>
  )
}

export default SEO
